import { render, staticRenderFns } from "./caracteristicsEvolution.vue?vue&type=template&id=53f7685b&scoped=true"
import script from "./caracteristicsEvolution.vue?vue&type=script&lang=js"
export * from "./caracteristicsEvolution.vue?vue&type=script&lang=js"
import style0 from "./caracteristicsEvolution.vue?vue&type=style&index=0&id=53f7685b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f7685b",
  null
  
)

export default component.exports